import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { useCompany } from "./CompanyContext";
const SettingContext = createContext();

export const useSetting = () => {
  return useContext(SettingContext);
};

export const SettingProvider = ({ children }) => {
  const { company } = useCompany();
  const [openSettingDialog, setOpenSettingDialog] = useState(false);
  const [vatOption, setVatOption] = useState('common');
  const [vatType, setVatType] = useState('exclusive');
  const [commonVatRate, setCommonVatRate] = useState(0);

  useEffect(() => {
    if (company) {
      setVatOption(company.vatOptions || 'common');
      setVatType(company.vatType || 'exclusive');
      setCommonVatRate(company.commonVatRate || 0);
    }
  }, [company]);

  const handleSettingDialogOpen = useCallback(() => {
    setOpenSettingDialog(true);
  }, []);

  const handleSettingDialogClose = useCallback(() => {
    setOpenSettingDialog(false);
  }, []);

  const handleVatChange = useCallback((event) => {
    setVatOption(event.target.value);
  }, []);

  const handleVatTypeChange = useCallback((event) => {
    setVatType(event.target.value);
  }, []);

  const handleCommonVatRateChange = useCallback((event) => {
    setCommonVatRate(event.target.value);
  }, []);

  const value = useMemo(
    () => ({
      openSettingDialog,
      setOpenSettingDialog,
      vatOption,
      setVatOption,
      vatType,
      setVatType,
      handleSettingDialogOpen,
      handleSettingDialogClose,
      handleVatChange,
      handleVatTypeChange,
      handleCommonVatRateChange,
      commonVatRate,
      setCommonVatRate,
    }),
    [
      openSettingDialog,
      vatOption,
      vatType,
      commonVatRate,
      handleSettingDialogOpen,
      handleSettingDialogClose,
      handleVatChange,
      handleVatTypeChange,
      handleCommonVatRateChange,
    ]
  );

  return (
    <SettingContext.Provider value={value}>
      {children}
    </SettingContext.Provider>
  );
};
